<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Paparan Bil Pelbagai" >

    <w-card bg-color="" class="">
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No. Bil :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.no_inbois}} </div>
            </div>
            
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Bil :
                  </h5>
                  <!-- <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.created_at)}}</div> -->
                  <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.tarikh_inbois)}}</div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Profil :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.profil ? form.profil.no_id : ''}} | {{form.profil ? form.profil.nama : ''}}</div>
            </div>
        </w-flex>
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Alamat :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.profil ? form.profil.alamat ? form.profil.alamat.alamat1 : '' : ''}} ,
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.alamat2 : '' : ''}},
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.alamat3 : '' : ''}},
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.lkp_poskod.keterangan : '' : ''}},
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.lkp_poskod.bandar : '' : ''}},
                    {{form.profil ? form.profil.alamat ? form.profil.alamat.lkp_negeri.keterangan : '' : ''}}
                </div>
            </div>
            
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Status :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.inbois_status ? form.inbois_status.keterangan : ''}} </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                  </h5>
                  <div class="fw-normal my1 fs-1"></div>
            </div>
            
        </w-flex>

    <template v-if="form.lkp_inbois_status_id == 3">  
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No. Resit :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.no_resit}}</div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No. Rujukan :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.no_rujukan}} </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Cara Bayaran :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.resit ? form.resit.cara_bayaran.keterangan : ''}} </div>
            </div>
        </w-flex>
        <w-flex justify-left align-left>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Bayar :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.tarikh_bayar}}</div>
            </div>
            
        </w-flex>
    </template>
    </w-card>


    <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>

    <w-tabs :items="tabs" :no-slider="false" active-class="primary">  
    <template #item-content.1>  

        <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">  

        <!-- <template v-if="form.lkp_inbois_status_id == 4 || form.lkp_inbois_status_id == 3">   -->
            <w-flex justify-center align-center>
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                              <td >No</td>
                              <td>Kod Akaun</td>
                              <td>Vot</td>
                              <td>Butiran</td>
                              <td>Kuantiti</td>
                              <td>Kadar (RM)</td>
                              <td>Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="dt, index in form.butiran">
                            <td>{{(index+1)}}</td>
                            <td >
                                {{dt.akaun.kod}} | {{dt.akaun.keterangan}} 
                            </td>
                            <td>
                                {{dt.vot ? dt.vot.kod : '' }}
                                <template v-if="dt.vot.keterangan != null"> | </template>
                                {{dt.vot.keterangan}}
                            </td>
                            <td>
                                {{dt.keterangan.toUpperCase()}}
                            </td>
                            <td>
                              {{dt.kuantiti}}
                            </td>
                            <td align="right">
                                {{$zutil.currency(dt.kadar)}}
                            </td>
                            <td align="right">
                                {{$zutil.currency(dt.amaun)}}
                            </td>
                        </tr>
                        <tr >
                          <td colspan="6"><b>Jumlah</b></td>
                          <td align="right"><b>{{$zutil.currency(form.amaun)}}</b></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
            

             <w-flex class="mt3" wrap align-center justify-end>
                <!-- <template v-if="form.lkp_inbois_status_id == 2" > -->
                    <template v-if="form.lkp_inbois_status_id == 2 && $zutil.can('BilPelbagai Batalkan')" >
                        <w-button class="my1" bg-color="error-dark1" dark  @click="send(4)" >
                             <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                        </w-button>
                    </template>
                        &nbsp;&nbsp;

                    <template v-if="form.lkp_inbois_status_id == 2 || form.lkp_inbois_status_id == 3" >
                        <w-button bg-color="success" class="mr3" @click="cetak()">
                            <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                        </w-button>
                    </template>
                        &nbsp;
                    <template v-if="form.lkp_inbois_status_id == 3" >
                        <w-button bg-color="success" class="mr3" @click="cetakResit()">
                            <w-icon>fal fa-print</w-icon>&nbsp;Cetak Resit
                        </w-button>
                    </template>

                   
            </w-flex>
        <!-- </template> -->

        </w-form>
      </template>
      <template #item-content.2>
        <!-- <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess"> 
        <w-flex justify-center align-center>
          <div class="w-card__content content-hardcode">

              <table class="table-dashboard" width="100%">
                  <thead>
                  <tr>
                      <td >No</td>
                      <td >Tindakan</td>
                      <td >Pengguna</td>
                      <td >Tarikh</td>
                      <td>Catatan</td>
                  </tr>
                  </thead>
                  <tbody>
                  
                      <tr v-for="dt, index in form.jejak_audit">
                          <td class="w-table__cell text-left">
                              {{(index + 1)}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.tindakan_keterangan}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.user_nama}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.tarikh}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.catatan}}
                          </td>
                      </tr>
                      <tr v-if="form.jejak_audit.length == 0">
                          <td class="w-table__cell text-left" colspan="5">
                          </td>
                      </tr>
                  </tbody>
                  
              </table>
            </div>
          </w-flex>
        </w-form> -->
            <z-jejak-audit :jejak_audit="form.jejak_audit"/>
      </template>
    </w-tabs>
  
    </z-page>
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
    resourceurl: this.service_bil_pelbagai+'inbois',
    reload: true,
    loading: true,
      
      tabs: [
          { title: 'Butiran', content: '' },
          { title: 'Jejak Audit', content: '' },
      ],
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Bil Pelbagai', route: '/inbois' },
        { label: 'Papar', route: '/inbois/'+this.id },
      ],
    }
  },
    methods: {

    addItem() {
        this.form.butiran.push( {akaun_id : null, keterangan : null, kuantiti : null, kadar : null, amaun : null});
    },

    removeItem(index) {
        this.form.butiran.splice(index, 1);
    },

     cekAmaun(){
      this.form.amaun = 0;
      for (var i in this.form.butiran) {
        this.form.amaun = this.form.amaun + parseFloat(this.form.butiran[i].amaun);
        }
    },

    cekJumlah(dt){
      dt.amaun = dt.kuantiti * dt.kadar
      this.cekAmaun()
      // for (var i in this.form.butiran) {
        // }
    },

    send(status){
      this.form.lkp_inbois_status_id = status
      this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                      this.$inertia.visit(this.$route('inbois.index'))
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    
    },

    cetak(id) {
            // window.location.href = this.service_bil_pelbagai+'api/inbois/cetak'+id;
            // window.location.href = this.service_bil_pelbagai+'inbois/cetak/'+this.id;
        window.open(this.service_bil_pelbagai+'inbois/cetak/'+this.id);
        },

    cetakResit() {
        // alert(this.form.resit.id);
        // window.location.href = this.service_kutipan+'resit/cetak/'+this.form.resit.id;
        window.open(this.service_kutipan+'resit/cetak/'+this.form.resit.id);
    },
    getData()  {
          var app = this;

          if(this.id){
            if(this.id > 0){
              this.$zcomm.get(this.service_bil_pelbagai +'inbois/'+this.id+''+window.location.search).then(res => {
                this.form = res;
                // this.cekAmaunResit();

              })
              .finally(() => {

                this.loading = false
              });
            }
          }
          
          
        },
        
  },
  watch: {

  },
  mounted() {
    this.getData();
    
      
  },
    
}
</script>